import type { RoleConfig } from '../types.js';

export const bodyguard: RoleConfig = {
  id: 'bodyguard',
  faction: 'town',
  title: { ru: 'Телохранитель', uk: 'Охоронець' },
  latin: 'BODYGUARD',
  number: '11',
  accent: '#86c9ff',
  ability: {
    ru: 'Ночью защищает игрока — принимает удар на себя и погибает вместо него.',
    uk: 'Вночі захищає гравця — приймає удар на себе й гине замість нього.',
  },
  abilities: [
    { key: 'protect', phase: 'night', cadence: 'every-night', canSelfTarget: false },
  ],
  victory: { type: 'town' },
};
